export const messages = {
  title: {
    id: "bible-header.title",
    defaultMessage: "The Book of",
  },
};
